import React, { useContext, useState } from 'react';
// import { Link } from 'react-router-dom';
import Logo from '../../images/Logo.png'
import { AuthContext } from '../../App';
import { Link, Navigate } from 'react-router-dom';
import url from '../url';
const axios = require('axios');

const Login = () => {
    const {auth, dispatchAuth } = useContext(AuthContext)
    const [errors, setErrors]=useState([])
    const [error, setError]=useState('')
    
    const [email, setEmail]=useState('')
    const [password, setPassword]=useState('')
    
    const [spin, setSpin]=useState(false)
    const [success, setSucess]=useState(false)

    const rendererrors=errors.map(error=>(
        <ul>
            <li>{error}</li>
        </ul>
    ))

    const signIn=()=>{
        // alert(url)
        setErrors([])
        
        setSpin(true)
        axios.post(url+'hms/auth/manager/login',
        {
			// "name":firstname+' '+lastname,
			"email":email,
			"password":password,
			"type":"DOCTOR"
		}).
        then(res=>{
            // console.log(res)
            if (res.data.success) {
                // alert('success')
                // 1. Dispatch to context 
                var abc= res.data.result
                dispatchAuth({type:'login_status',value:true})
                dispatchAuth({type:'user',value:JSON.stringify(abc)})
                dispatchAuth({type:'token',value:res.data.result.accessToken})
                dispatchAuth({type:'userid',value:res.data.result.id})
                // 2. write to session storage
      
                sessionStorage.setItem('logged_in', true);
                sessionStorage.setItem('user', JSON.stringify(abc));
                sessionStorage.setItem('token', res.data.result.accessToken);
                sessionStorage.setItem('userid', res.data.result.id);
      
                setSucess(true)
              } else {
                // setError('Wrong username or password')
              }
        }).catch(e=>{
            // console.log(e.response.message)
            // console.log('e.response.message')
            if(e.response.status==422){
                setErrors(e.response.data.result)

            }else if(e.response.status==401){
                setError(e.response.data.message)

            }
            
            else{
                setError('Error Login In')

            }
            

        }).then(re=>{
            setSpin(false)

        })
        const rendererrors=errors.map(error=>(
            <ul>
                <li>{error}</li>
            </ul>
        ))
        // https://diagnostic-api-test.bostonresearch.ai/api/hms/auth/user/register

    }
    return (<>
    {success ? <>
      <Navigate to="/dashboard" />
    
    </> : <></>}
   <div class=" bg-blue-200 font-ssans flex h-screen">
    <div class="mx-auto m-8 space-y-6 w-full md:w-3/4 ">
        <div className='mx-auto md:w-1/4 w-1/2 '>
        <img src={Logo}  />
            
        </div>
        <div className='border-2 border-blue-500 rounded-lg bg-white flex md:w-1/2 mx-auto'>
           
        <div className='flex flex-col flex-auto mx-20 my-10 '>
        <div class="mb-3 w-full text-red-500">
        {/* <label for="email" class="block mb-2 text-sm font-medium text-blue-900 dark:text-blue-600">Email</label> */}
        {rendererrors}
        {error}
        
        </div>
        <div class="mb-3 w-full">
        {/* <label for="email" class="block mb-2 text-sm font-medium text-blue-900 dark:text-blue-600">Email</label> */}
        <input type="email"  class="text-blue-500 border-b border-blue-500  text-sm   focus:border-blue-500  w-full p-2.5  placeholder-blue-500 dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder="Email" required="" value={email} onChange={(e)=>setEmail(e.target.value)} />
        
        </div>
        <div class="mb-3 w-full">
        {/* <label for="email" class="block mb-2 text-sm font-medium text-blue-900 dark:text-blue-600">Email</label> */}
        <input type="password"  class="text-blue-500 border-b border-blue-500  text-sm   focus:border-blue-500  w-full p-2.5  placeholder-blue-500 dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder="Password" required="" value={password} onChange={(e)=>setPassword(e.target.value)} />
        
        </div>
        {/* <div class="flex items-start mb-6">
        <div class="flex items-center h-5">
        <input id="remember" type="checkbox" value="" class="w-4 h-4 border border-gray-300 rounded bg-gray-50 focus:ring-3 focus:ring-blue-300 dark:bg-gray-700 dark:border-gray-600 dark:focus:ring-blue-600 dark:ring-offset-gray-800" required="" />
        </div>
        <label for="remember" class="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300">Remember me</label>
        </div> */}
        <div>
            {spin? <>
                <svg role="status" class="inline w-10 h-10 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
                    <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
                </svg>
                            
             </> : <> </>}
        </div>

<button type="submit" class="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800 mx-4 my-4"
onClick={()=>signIn()}>Login</button>
{/* <button type="submit" class="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center dark:bg-blue-300 dark:hover:bg-blue-500 dark:focus:ring-blue-800 mx-4">Sign Up</button> */}
<Link to="/signup" class="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center dark:bg-blue-300 dark:hover:bg-blue-500 dark:focus:ring-blue-800 mx-4"> Sign Up</Link>

        
        {/* <div className='flex flex-col w-1/2 mx-auto'>
            <div className='w-full flex flex-auto'>
            <button type="submit" class="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">Submit</button>
                
            </div>
            <div>
            <button type="submit" class="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">Submit</button>

            </div>
        </div> */}
        </div>


        </div>
        
    </div>
</div>
    </>  );
}
 
export default Login;